import { colors } from '@ui/colors'

export const InputStatuses = {
  success: 'success',
  disabled: 'disabled',
  default: 'default',
  focus: 'focus',
  error: 'error',
  readonly: 'readonly',
} as const

export type InputStatus = (typeof InputStatuses)[keyof typeof InputStatuses]

type StateToColor = Record<InputStatus, string>

export const backgroundColor: StateToColor = {
  success: colors.green[50],
  disabled: colors.black5,
  default: colors.neutral[50],
  focus: colors.white,
  error: colors.red[50],
  readonly: colors.white,
}

export const borderColor: StateToColor = {
  success: colors.green[600],
  disabled: colors.text0,
  default: colors.black10,
  focus: colors.text,
  error: colors.red[600],
  readonly: colors.black10,
}

export const borderColorLight: StateToColor = {
  success: colors.green[600],
  disabled: colors.white0,
  default: colors.white0,
  focus: colors.text,
  error: colors.red[600],
  readonly: colors.white0,
}

export const labelInlineColor: StateToColor = {
  success: colors.green[600],
  disabled: colors.black25,
  default: colors.black25,
  focus: colors.text,
  error: colors.red[600],
  readonly: colors.black25,
}

export const labelTopColor: StateToColor = {
  success: colors.green[600],
  disabled: colors.black25,
  default: colors.black25,
  focus: colors.text,
  error: colors.red[600],
  readonly: colors.black10,
}

export const requiredIndicatorColor: StateToColor = {
  success: colors.green[600],
  disabled: colors.text0,
  default: colors.orange[500],
  focus: colors.text,
  error: colors.red[600],
  readonly: colors.black10,
}
